<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div v-if="items.length > 0" class="overflow-auto">
      <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
        <thead>
        <tr>
          <th class="text-capitalize-first">{{ helper.trans('labels.merchant') }}</th>
          <th class="text-capitalize-first">{{ helper.trans('labels.store') }}</th>
          <th class="text-capitalize-first">{{ helper.trans('labels.pay_in_fee_percent') }}</th>
          <th class="text-capitalize-first">{{ helper.trans('labels.pay_in_reward_fee_type') }}</th>
          <th class="text-capitalize-first">{{ helper.trans('labels.pay_out_fee_percent') }}</th>
          <th class="text-capitalize-first">{{ helper.trans('labels.pay_out_reward_fee_type') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="`${item.merchantId}-${item.slot}-${item.storeId ?? 'all'}`">
          <td>
            <i v-if="item.isMerchantBlocked" v-b-tooltip.hover :title="helper.trans('labels.user_blocked')" class="fa fa-ban text-danger me-1"></i>
            {{ item.merchantName }}
          </td>
          <td>
            <span v-if="item.storeName">{{ item.storeName }}</span>
            <span v-else class="text-muted">{{ helper.trans('labels.referral_fees_all_stores') }}</span>
          </td>
          <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.payInFee), 1) }}%</td>
          <td>{{ helper.trans(`labels.ref_fee_type.${item.payInFeeType}`) }}</td>
          <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.payOutFee), 1) }}%</td>
          <td>{{ helper.trans(`labels.ref_fee_type.${item.payOutFeeType}`) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-muted text-capitalize-first">{{ helper.trans('labels.referral_merchant_fees_empty') }}</div>
  </LoaderWrapper>
</template>

<script lang="ts">

import {defineComponent, PropType, ref, watch} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import ReferralMerchantFeeDTO from "@/models/ReferralMerchantFeeDTO";

export default defineComponent({
  components: {
    LoaderWrapper
  },
  props: {
    referralId: {
      type: Number as PropType<number|undefined>,
      default: undefined
    }
  },
  setup(props) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      items: [] as ReferralMerchantFeeDTO[]
    })

    const load = async () => {
      loader.value?.show()
      try {
        state.items = await api.call.referrals.merchants(props.referralId)
      } catch (e) {
        state.items = []
      } finally {
        loader.value?.hide()
      }
    }

    watch(() => props.referralId, () => load(), {immediate: true})

    return {
      ...toRefs(state),
      loader,
      helper,
      numberFormatter
    }
  }
})
</script>
